import React from "react";
import WebsiteApp from "./components/website/website";

function App() {
  return (
    <>
      <WebsiteApp />
    </>
  );
}

export default App;
